/*jshint esversion: 8 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import store from '../../components/stores/Store';
import { webhost } from "../../config/ips";
import { signinWithOAuth } from "../../db/OAuthRequestHandler";
import { updateLocalStorageFields } from '../../utils/LocalStorageHandler';
import { sleep } from '../../utils/Sleep';
import { hostName, authClientId } from '../../config/ips';
import TradeStatistics from '../../components/TradeStatistics';
import { getIfFuncAuthorized } from '../../utils/CheckSomething';


const oathPath = `https://iam.zjgzhcs.com:443/idp/oauth2/authorize?redirect_uri=${webhost}/login/oauth2_callback&state=0&client_id=${authClientId}&response_type=code`;

const styles = {
  root: {
    flex: "1 1 auto",
    alignItems: "center",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    marginTop: '50px',
  },
  rootWelcome: {
    '& .MuiTextField-root': {
      margin: '10px',
      width: '25ch',
    },
  },
};
// HomeOAuth
class HomeOAuthInner extends Component {
  constructor() {
    super();
    this.state = {};
    this.signinWithOAuth = this.signinWithOAuth.bind(this);
  }

  async componentDidMount() {
    // store.userExist();
    if (webhost.includes('localhost')) {
      const d = new Date();
      this.setState({ localText: d.getMinutes() });
    }

    const href = window.location.href;

    await sleep(1000);
    if (href.includes('oauth2_callback') && !store.user.logined) {
      // 未登录
      console.log(`----- store.user.logined: `, store.user.logined);
      console.log(`----- store.user.uuid: `, store.user.uuid);
      this.signinWithOAuth(href);
    } else {
      // if (href.includes('oauth2_callback')) window.location.href = webhost;
    }
  }

  async signinWithOAuth(text) {
    console.log(`----- signinWithOAuth`);
    const iindex = text.indexOf('code=');
    const code = text.substr(iindex + 5, 32);
    // window.location.href = webhost;
    console.log(`----- code: `, code);
    const rst = await signinWithOAuth({ code });
    console.log(`----- signinWithOAuth-rst: `, rst);

    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '登陆失败');
      window.location.href = webhost;
    } else if (rst.code === 'success') {
      console.log(`----- rst: `, rst);
      store.userSignin({
        token: rst.token,
        marketId: rst.marketId,
        uuid: rst.uuid,
        memname: rst.memname,
        rolename: rst.rolename,
        authSettings: rst.rolePrivilege,
        phone: rst.phone || '',
      });
      console.log(`----- after userSignin-logined: `, store.user.logined);
      console.log(`----- after userSignin-authSettings: `, store.user.authSettings);
      updateLocalStorageFields({
        uuid: rst.uuid,
        token: rst.token,
        // marketId: rst.marketId || '9999',
      });
      // window.location.href = webhost;
    }
  }

  render() {
    const { classes } = this.props;
    if (store.user.rolename === '新注册用户') {
      return (
        <div className={classes.rootWelcome}>
          <Typography variant="h5" gutterBottom>
            主页
          </Typography>
          <Typography variant="h6" gutterBottom>
            新注册用户，请联系电话 13812588838
          </Typography>
        </div>
      );
    }
    if (store.user.logined && getIfFuncAuthorized('交易管理-交易记录统计')) {
      return (
        <>
          <Typography variant="h5" gutterBottom>
            交易记录统计
          </Typography>
          <div className={classes.rootWelcome}>
            <TradeStatistics />
          </div>
        </>
      );
    };
    if (store.user.logined && !getIfFuncAuthorized('交易管理-交易记录统计')) {
      return (
        <>
          <Typography variant="h5" gutterBottom>
            欢迎使用
          </Typography>
        </>
      );
    };
    return (
      <div className={classes.root}>
        <div>
          <Typography variant="h4">
            {hostName || ''}房票系统
          </Typography>

          <Button
            size="large"
            color="primary"
            variant="contained"
            style={{
              margin: '10rem 0 0 0',
              padding: '0 0 0 0',
            }}
            onClick={this.oathLogin}
          >
            <a
              href={oathPath}
              rel="noopener noreferrer external"
              style={{
                color: 'white',
                fontSize: '15px',
                textDecoration: 'none',
                width: '200px',
                padding: '10px 100px 10px 100px'
              }}
            >
              统 一 授 权 登 陆
            </a>
          </Button>

          {false && (
            <Button
              size="large"
              color="primary"
              variant="contained"
              style={{
                margin: '60px 0 0 0',
                padding: '0 0 0 0',
              }}
            >
              <a
                href={`https://iam.zjgzhcs.com:443/idp/profile/OAUTH2/Redirect/GLO?redirctToUrl=${webhost}&redirectToLogin=true&entityId=${authClientId}`}
                rel="noopener noreferrer external"
                style={{
                  color: 'white',
                  fontSize: '15px',
                  textDecoration: 'none',
                  width: '200px',
                  padding: '10px 100px 10px 100px'
                }}
              >
                退 出
              </a>
            </Button>
          )}

        </div>
        {/* <MessageDialog /> */}
      </div>
    );
  }
}

const HomeOAuth = observer(HomeOAuthInner);

HomeOAuth.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HomeOAuth);
